/* eslint-disable max-lines */
export interface DashboardResponse {
  MQMBalance: string;
  accessToken: string;
  adminCompanyName: string;
  canBookBasicEconomy: string;
  canBookNonRefundable: string;
  cartCnt: string;
  cartID: string;
  contractMgtEnt: string;
  country: string;
  crprtAgrmntFound: boolean;
  crprtAgrmntId: string;
  crprtAgrmntTypeCode: string;
  crprtName: string;
  crprtPricingDiscCode: string;
  customerID: string;
  cobrandCardtypeList: string;
  enrollmentDate: string;
  errors: Partial<DashboardResponseError[]>;
  firstName: string;
  firstTime: boolean;
  formNameSubmitted: string;
  hasEmail: boolean;
  hasNuTvl: string;
  hasSQA: boolean;
  hasTripLink: string;
  hasUserNm: boolean;
  hasPhone: boolean;
  irop: boolean;
  is360Tier: boolean;
  isAbove18: boolean;
  isEmailValid: boolean;
  isWarmState: boolean;
  langPromptIndicator: boolean;
  language: string;
  lastName: string;
  loggedIn: boolean;
  loyaltyPromoInd: string;
  loyaltyPromoLink: string;
  medallionMbrInd: string;
  medallionMemberDesc: string;
  membershipLevel: string;
  middleName: string;
  milesExpireDate: string;
  millionMiler: boolean;
  millionMilerTier: string;
  nameSuffix: string;
  permType: string;
  pgmType: string;
  preferredName: string;
  prefix: string;
  primaryEmailAddress: string;
  program: string;
  promoCdInd: boolean;
  pwmMbr: boolean;
  rememberMeFirstName: string;
  rememberMeID: string;
  rememberMeIndicator: boolean;
  rememberMeLastName: string;
  skyPriority: boolean;
  skymilesMember: boolean;
  smBalance: string;
  smNumber: string;
  smeCardTypes: string;
  smeCompanyName: string;
  spgInd: boolean;
  spid: string;
  sysDrvdPrefHomeArptCd: string;
  triplinkErrorCd: string;
  userId: string;
  userNameType: string;
  usrProvdPrefHomeArptCd: string;
  venderID: string;
  isSkyClubMember: string;
  skyClubMemberType?: string;
  skyClubMembershipDiscontinueDate?: string;
  emailAddressLocalDate: string;
  hasTravelPolicy?: string;
  cobrandCardtypeAffiliationIdList: string;
  cobrandCardtypeDescList: string;
  cobrandCardtypeSkyclubEligibleList: string;
}

export interface DashboardResponseError {
  code: string;
  description: string;
  inputParam: string;
  message: string;
  stackTrace: string;
}

export interface LoginAndGetDashboardRequest {
  debug?: string;
  eamToken?: string;
  formNameSubmitted: string;
  fromApp?: string;
  persistentLogin?: string;
  refreshURL: string | null;
  rememberMe: string;
  transactionId?: string;
  updateIropInd?: string;
  updateNameInd?: string;
  updatePartnerInfoInd?: string;
  updateSmBalInd?: string;
  tokenId?: string;
}

export interface LoginAndGetDashboardResponse {
  errors?: [
    {
      code: string;
    }
  ];
  refreshURL?: string;
  isLoggedIn?: boolean;
  isWarmState?: boolean;
  formNameSubmitted?: string;
  isBusiness?: boolean;
  hasSQA?: boolean;
  hasEmail?: boolean;
  isEmailValid?: boolean;
  isSMEOnly?: boolean;
  MQMBalance?: string;
  accessToken?: string;
  adminCompanyName?: string;
  contractMgtEnt?: string;
  country?: string;
  crprtAgrmntFound?: boolean;
  crprtAgrmntId?: string;
  crprtAgrmntTypeCode?: string;
  crprtName?: string;
  crprtPricingDiscCode?: string;
  customerID?: string;
  enrollmentDate?: string;
  firstName?: string;
  firstTime?: boolean;
  hasNuTvl?: string;
  hasTripLink?: string;
  hasUserNm?: boolean;
  irop?: boolean;
  is360Tier?: boolean;
  langPromptIndicator?: boolean;
  language?: string;
  lastName?: string;
  loggedIn?: boolean;
  loyaltyPromoInd?: string;
  loyaltyPromoLink?: string;
  medallionMbrInd?: string;
  medallionMemberDesc?: string;
  membershipLevel?: string;
  millionMiler?: boolean;
  permType?: string;
  pgmType?: string;
  preferredName?: string;
  prefix?: string;
  primaryEmailAddress?: string;
  program?: string;
  promoCdInd?: boolean;
  pwmMbr?: boolean;
  rememberMeIndicator?: boolean;
  skyPriority?: boolean;
  skymilesMember?: boolean;
  smBalance?: string;
  smNumber?: string;
  smeCardTypes?: string;
  spgInd?: boolean;
  sysDrvdPrefHomeArptCd?: string;
  userId?: string;
  usrProvdPrefHomeArptCd?: string;
  queryParams?: string;
  emailAddressLocalDate?: string;
  smType?: string;
  loginMethod?: string;
}
